import { CSSProperties, StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import {
	adsModuleBadge,
	background,
	borderColor,
	brandPrimary,
	brandPrimaryHover,
	brandSecondary,
	brandSecondaryHover,
	darkGrayFontColor,
	destructive,
	header,
	navigation,
	potionPink,
	success,
	titles,
	toggleOff,
	warningDark,
	white,
} from '../../../../web/styles/colors';
import { shadowSm } from '../../../../web/styles/shadows';
import { absoluteCenterStyle, baseStyles, CssSelectors } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	accountDetailsContainer: {
		marginTop: 20,
	},
	willRenewPredictionValue: {
		alignItems: 'center',
		display: 'inline-flex',
		gap: THEME.spacing.xs,
	},
	accountName: {
		fontWeight: 100,
		color: titles,
		textDecoration: 'none',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		display: 'block',
		':hover': {
			color: brandPrimaryHover,
			textDecoration: 'underline',
		},
		cursor: 'pointer',
	},
	actionButton: {
		color: 'rgb(118, 118, 118)',
	},
	actionEntities: {
		alignItems: 'center',
		color: darkGrayFontColor,
		cursor: 'pointer',
		display: 'inline-flex',
		fontSize: 13,
		whiteSpace: 'nowrap',
		transition: 'color 300ms ease',
		':hover': {
			color: brandPrimary,
		},
	},
	actionEntitiesReadOnly: {
		alignItems: 'center',
		color: darkGrayFontColor,
		display: 'inline-flex',
		fontSize: 13,
		whiteSpace: 'nowrap',
	},
	actionEntitiesBar: {
		alignItems: 'center',
		display: 'flex',
		flexShrink: 0,
		gap: 16,
	},
	alertFigure: {
		marginRight: 4,
	},
	healthScoreCircle: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 36,
		height: 36,
		borderRadius: '50%',
		fontSize: 13,
		fontWeight: 700,
		color: white,
		marginLeft: 30,
		alignSelf: 'flex-start',
		flexShrink: 0,
	},
	healthScoreGreen: {
		backgroundColor: success,
	},
	healthScoreOrange: {
		backgroundColor: warningDark,
	},
	healthScoreRed: {
		backgroundColor: destructive,
	},
	healthScoreNA: {
		backgroundColor: darkGrayFontColor,
		fontSize: 11,
	},
	alertMessage: {
		color: toggleOff,
		fontSize: 12,
		lineHeight: '22px',
		margin: 0,
	},
	alertMessageWrap: {
		alignItems: 'center',
		display: 'flex',
		flex: '0 1 40%',
		height: 22,
	},
	applyButton: {
		marginRight: 20,
	},
	autocompleteBox: {},
	breadcrumbsContainer: {
		alignItems: 'center',
		display: 'flex',
		gap: 12,
	},
	billingStatus: {
		display: 'flex',
		flexDirection: 'row',
		gap: 10,
	},
	billingStatusAlertText: {
		color: destructive,
		fontWeight: 'bold',
	},
	cancelAccountModal: {
		maxWidth: 380,
	},
	centerDiscountIcon: {
		height: 20,
		width: 20,
	},
	centerTrashIcon: {
		display: 'block',
		margin: '0 2px',
	},
	childList: {
		marginLeft: 27,
		marginTop: 4,
		width: '100%',
	},
	childListItem: {
		fontSize: 13,
	},
	clipboardIcon: {
		height: 18,
		width: 20,
	},
	coffeeLogo: {
		height: 20,
		width: 20,
	},
	companyName: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'nowrap',
		fontSize: 24,
		gap: 16,
		justifyContent: 'space-between',
	},
	companyNameInput: {
		width: 300,
	},
	container: {},
	configureEmailButton: {
		marginBottom: 20,
	},
	dayPickerContainer: {
		background: '#FFF',
		border: `1px solid ${borderColor}`,
		borderRadius: 3,
		padding: '20px 0px',
	},
	details: {
		marginTop: 30,
	},
	detailsCheckbox: {
		marginTop: 10,
	},
	detailsColumns: {
		position: 'relative',
	},
	discountTitle: {
		color: brandSecondaryHover,
	},
	discountComboboxContainer: {
		margin: '20px 0',
		minWidth: 200,
	},
	downloadPDFTitle: {
		margin: '6px 0',
	},
	dropDown: {
		fontSize: 12,
		height: 30,
		marginBottom: 10,
		maxWidth: 200,
		width: 'calc(100% - 10px)',
	},
	dropdownMenu: {
		fontSize: 14,
		position: 'relative',
		width: 'auto',
	},
	emailNotConfigured: {
		display: 'inline-flex',
		marginBottom: 20,
		marginRight: 30,
	},
	emailNotConfiguredText: {
		color: destructive,
	},
	hawksoftInfo: {
		color: navigation,
		fontSize: 13,
		marginTop: 6,
	},
	highlightIcon: {
		height: 18,
		width: 'auto',
	},
	iconLevitateAccess: {
		height: 18,
		marginRight: 8,
		width: 18,
	},
	iconScheduleMeeting: {
		height: 18,
		marginRight: 8,
		width: 18,
	},
	iconCustomerAssistant: {
		display: 'inline-flex',
		marginRight: 8,
	},
	iconStickyNote: {
		color: potionPink,
		marginRight: 8,
	},
	iconUnsubscribe: {
		height: 18,
		marginRight: 8,
		width: 18,
	},
	implementationBadge: {
		backgroundColor: destructive,
		borderRadius: 4,
		color: white,
		fontSize: 12,
		fontWeight: 600,
		letterSpacing: 0.5,
		padding: '2px 8px',
		textTransform: 'uppercase' as const,
		whiteSpace: 'nowrap' as const,
	},
	vipBadge: {
		backgroundColor: success,
		borderRadius: 4,
		color: white,
		fontSize: 12,
		fontWeight: 600,
		letterSpacing: 0.5,
		padding: '2px 8px',
		textTransform: 'uppercase' as const,
		whiteSpace: 'nowrap' as const,
	},
	billingTypeBadge: {
		backgroundColor: brandSecondary,
		borderRadius: 4,
		color: white,
		fontSize: 12,
		fontWeight: 600,
		letterSpacing: 0.5,
		padding: '2px 8px',
		textTransform: 'uppercase' as const,
		whiteSpace: 'nowrap' as const,
	},
	includeIntegrationsCheckbox: {
		color: 'black',
		fontSize: 14,
		fontWeight: 'bolder',
		margin: 20,
	},
	includeIntegrationsCheckboxContainer: {
		paddingLeft: 80,
	},
	infoFieldTall: {
		marginTop: 30,
	},
	infoFieldUnsetHeight: {
		height: 'unset',
	},
	leftContainer: {
		width: '25%',
	},
	levitateAccessUntilText: {
		fontSize: 12,
	},
	linkContainer: {
		padding: 0,
	},
	linkContainerWrap: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		margin: '0 0 10px 0',
	},
	linkIcon: {
		cursor: 'pointer',
		height: 'auto',
		marginLeft: 10,
		marginTop: 6,
		width: 20,
	},
	companyNameColumn: {
		display: 'flex',
		flexDirection: 'column',
	},
	copyLinkButton: {
		background: 'none',
		border: 'none',
		color: navigation,
		cursor: 'pointer',
		fontSize: 12,
		padding: 0,
		':hover': {
			color: brandPrimaryHover,
			textDecoration: 'underline',
		},
	},
	listItem: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'inline-flex',
		fontSize: 14,
		textDecoration: 'none',
	},
	loading: {
		...absoluteCenterStyle,
	},
	moreMenu: {
		minWidth: 240,
		width: 'auto',
	},
	nextMeetingValue: {
		cursor: 'pointer',
	},
	noDecoration: {
		marginLeft: 12,
		textDecoration: 'none',
	},
	notes: {
		marginTop: 10,
		...CssSelectors.allChildren({
			alignItems: 'flex-start',
		}),
	},
	overviewContainer: {
		border: '1px solid #D3DBDE',
		borderRadius: 10,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.1)',
		boxSizing: 'border-box',
		display: 'flex',
		justifyContent: 'flex-end',
		padding: '20px 30px',
		width: '100%',
	},
	overviewContainerColumn: {
		':not(:first-child)': {
			paddingLeft: 10,
		},
		flexGrow: 1,
		paddingLeft: 0,
	},
	overviewContainerColumnSmall: {
		':not(:first-child)': {
			paddingLeft: 10,
		},
		// flexBasis: '15%',
		paddingLeft: 0,
	},
	pendingBillingCycleChangeText: {
		color: THEME.colors.warning.dark,
		fontSize: 12,
		fontStyle: 'italic',
		marginTop: 4,
	},
	pendingCancellationText: {
		color: destructive,
	},
	stillInContractText: {
		color: warningDark,
		fontSize: 12,
		marginTop: 4,
	},
	contractWarning: {
		color: destructive,
		fontSize: 13,
		fontWeight: 'bold',
		marginBottom: 10,
		marginTop: 10,
	},
	percentAmount: {
		background,
		border: '2px solid #E4E8EA',
		borderRadius: 3,
		cursor: 'pointer',
		margin: '20px 20px 20px 0',
		padding: '12px 20px',
	},
	percentSelected: {
		border: `2px solid ${brandPrimaryHover}`,
	},
	popover: {
		bottom: -10,
		minWidth: 150,
	},
	popoverKeyValue: {
		...CssSelectors.allChildren(
			{
				':first-child': {
					color: header,
					marginRight: 6,
				},
				':last-child': {
					color: titles,
				},
			},
			'span'
		),
	},
	popoverTitle: {
		color: brandPrimaryHover,
		fontSize: 16,
		marginBottom: 8,
	},
	providerNotConfigured: {
		color: destructive,
		fontWeight: 700,
	},
	resetAccountModal: {
		border: '2px solid #D0021B',
		borderRadius: 4,
		margin: '-22px',
		maxWidth: 380,
		padding: 20,
		paddingBottom: 30,
	},
	resetAccountModalBodyText1: {
		color: darkGrayFontColor,
		fontSize: 14,
	},
	resetAccountModalBodyText2: {
		color: darkGrayFontColor,
		fontSize: 14,
		paddingBottom: 20,
		paddingTop: 20,
	},
	resetAccountModalHeaderText: {
		color: '#D0021B',
		fontSize: 18,
		paddingBottom: 20,
		paddingTop: 20,
	},
	resetAccountModalWarningText: {
		color: '#D0021B',
		fontSize: 14,
	},
	rightSection: {
		width: '75%',
	},
	searchBox: {
		':nth-child(1n)': {
			padding: 5,
			paddingLeft: 10,
		},
	},
	selectCancellation: {
		...(baseStyles.textField as CSSProperties),
		alignItems: 'center',
		height: 30,
		minWidth: 300,
		marginBottom: 6,
	},
	selectTrigger: {
		...(baseStyles.textField as CSSProperties),
		height: 30,
		minWidth: 165,
	},
	showingDropdown: {
		minWidth: 190,
	},
	selectContent: {
		width: '100% !important',
	},
	spinner: {
		width: 10,
	},
	statusColorContainer: {
		alignItems: 'center',
		display: 'inline-flex',
		minWidth: 0,
		overflow: 'hidden',
	},
	hipaaIcon: {
		marginLeft: 8,
		marginRight: 8,
	},
	summaryTextInput: {
		height: 31,
		maxWidth: 120,
	},
	summaryTextInputAccessory: {
		maxWidth: 120,
	},
	textBox: {
		background: '#f9f9f9',
		border: '1px solid #ccc',
		borderRadius: 3,
		boxSizing: 'border-box',
		color: '#0d0f11',
		fontSize: 14,
		height: 30,
		maxWidth: 140,
		minWidth: 95,
		padding: '5px 5px 5px 10px',
		width: 'calc(100% - 10px)',
	},
	telephonyStatusPopoverContent: {
		maxWidth: 420,
		fontSize: 14,
	},
	textBoxFill: {
		':focus': {
			outline: 'none',
		},
		background: '#f9f9f9',
		border: '1px solid #ccc',
		borderRadius: 3,
		boxSizing: 'border-box',
		color: '#0d0f11',
		fontSize: 14,
		height: 40,
		padding: '5px 5px 5px 10px',
		width: 'calc(100% - 10px)',
	},
	trialExtended: {
		color: brandSecondary,
		fontSize: 12,
	},
	websiteLink: {
		fontSize: 14,
	},
	websiteOverviewContainer: {
		marginTop: 10,
		flexWrap: 'wrap',
	},
	moduleContainer: {
		marginBottom: 20,
	},
	moduleTagRow: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap' as const,
		gap: 8,
		width: '100%',
		marginBottom: 8,
	},
	generalInfoGrid: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr 1fr auto',
		width: '100%',
	},
	statusIndicatorsRow: {
		display: 'flex',
		flexWrap: 'wrap' as const,
		gap: 8,
	},
	statusChip: {
		display: 'inline-flex',
		alignItems: 'center',
		padding: '4px 10px',
		borderRadius: 12,
		fontSize: 12,
		fontWeight: 600,
		lineHeight: '16px',
		whiteSpace: 'nowrap' as const,
	},
	statusChipPositive: {
		backgroundColor: success,
		color: white,
	},
	statusChipNegative: {
		backgroundColor: destructive,
		color: white,
	},
	statusChipWarning: {
		backgroundColor: warningDark,
		color: white,
	},
	billingActionsRow: {
		display: 'flex',
		flexWrap: 'wrap' as const,
		gap: 16,
		width: '100%',
		marginTop: 4,
	},
	planAdditionalComponentsRow: {
		display: 'flex',
		flexWrap: 'wrap' as const,
		gap: 4,
		width: '100%',
	},
	customCalendarOverviewContainer: {
		marginTop: 10,
		flexWrap: 'wrap',
	},
	customCalendarSelectBox: {
		maxWidth: 200,
		fontSize: 14,
	},
	editIcon: {
		width: 16,
		height: 16,
	},
	websiteStageAlert: {
		color: destructive,
	},
	adsLiveDateRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		flexWrap: 'wrap' as const,
	},
	adsLiveDateButton: {
		background: 'none',
		border: 'none',
		color: brandPrimary,
		cursor: 'pointer',
		padding: '2px 6px',
		fontSize: 13,
		':hover': {
			textDecoration: 'underline',
		},
	},
	adsLiveDateInputGroup: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		flexWrap: 'wrap' as const,
	},
	adsLiveDatePrimaryButton: {
		padding: '4px 10px',
		fontSize: 12,
		fontWeight: 600,
		cursor: 'pointer',
		borderRadius: 4,
		border: `1px solid ${brandPrimary}`,
		backgroundColor: brandPrimary,
		color: white,
		':hover': {
			backgroundColor: brandPrimaryHover,
			borderColor: brandPrimaryHover,
		},
		':disabled': {
			opacity: 0.6,
			cursor: 'not-allowed',
		},
	},
	adsLiveDateSecondaryButton: {
		padding: '4px 10px',
		fontSize: 12,
		fontWeight: 600,
		cursor: 'pointer',
		borderRadius: 4,
		border: `1px solid ${borderColor}`,
		backgroundColor: white,
		color: darkGrayFontColor,
		':hover': {
			backgroundColor: background,
		},
		':disabled': {
			opacity: 0.6,
			cursor: 'not-allowed',
		},
	},
	adsEmptyChannelsMessage: {
		padding: '12px 16px',
		marginTop: 12,
		borderRadius: 4,
		backgroundColor: background,
		fontSize: 13,
		color: darkGrayFontColor,
		fontStyle: 'italic',
	},
	adsFullyLivePending: {
		fontSize: 12,
		color: warningDark,
		marginTop: 4,
	},
	billingActionLink: {
		display: 'block',
		marginBottom: 8,
	},
	loadingIndicator: {
		color: '#777',
		fontStyle: 'italic',
		fontSize: '0.9em',
	},
	popupHelperText: {
		color: '#777',
		fontSize: '0.85em',
		fontStyle: 'italic',
		marginTop: 4,
	},
	balanceDisplayTitle: {
		marginTop: 16,
	},
	compEditPlanLabel: {
		paddingBottom: 5,
	},
	compLinkToggle: {
		display: 'block',
		fontSize: 12,
		marginTop: 4,
	},
	editModeBar: {
		position: 'fixed' as const,
		bottom: 0,
		left: 0,
		right: 0,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '12px 24px',
		backgroundColor: white,
		borderTop: `1px solid ${borderColor}`,
		boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.1)',
		zIndex: 100,
	},
	adsLiveStatusTag: {
		display: 'inline-block',
		padding: '2px 10px',
		borderRadius: 12,
		fontSize: 11,
		fontWeight: 600,
		lineHeight: '16px',
		textTransform: 'uppercase' as const,
		letterSpacing: 0.4,
		color: white,
	},
	adsLiveStatusTagPositive: {
		backgroundColor: success,
	},
	adsLiveStatusTagNegative: {
		backgroundColor: destructive,
	},
	adsStageInlineAlert: {
		color: destructive,
		fontWeight: 500,
	},
	// Vertical stack that holds the ads section's bordered boxes (General Info +
	// one per channel). Replaces the old single flat container.
	adsSectionStack: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		width: '100%',
		marginTop: THEME.spacing.sm,
	},
	// Bordered box around each ads section. Matches the Overview tab's box styling
	// (same border/radius/shadow as overviewContainer) but lays out as a column and
	// uses a plain text heading instead of a ModuleTag pill.
	adsSectionBox: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		boxShadow: shadowSm,
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		padding: `${THEME.spacing.lg}px ${THEME.spacing.xl}px`,
		width: '100%',
	},
	adsSectionHeader: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		width: '100%',
		marginBottom: THEME.spacing.sm,
	},
	adsSectionTitle: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		margin: 0,
	},
	adsStageTag: {
		display: 'inline-block',
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		borderRadius: THEME.common.borderRadius,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.bold,
		backgroundColor: adsModuleBadge,
		color: white,
	},
	adsStageTagAlert: {
		fontWeight: THEME.typography.fontWeights.standard,
		opacity: 0.85,
	},
	adsStageCombobox: {
		minWidth: 180,
	},
	adsFieldsGrid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(3, 1fr)',
		gap: 12,
		width: '100%',
	},
	adsSectionEditButton: {
		display: 'flex',
		alignItems: 'center',
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		color: brandPrimary,
		fontSize: 14,
		fontWeight: 500,
		padding: 0,
		marginLeft: 'auto',
		':hover': {
			color: brandPrimaryHover,
		},
	},
	adsSectionEditLabel: {
		marginLeft: 6,
	},
});
